import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "ngx-video-player-modal",
  templateUrl: "./video-player-modal.component.html",
  styleUrls: ["./video-player-modal.component.scss"],
  standalone: true,
})
export class VideoPlayerModalComponent implements OnInit {
  @Input() videoSrc: string;
  constructor() {}

  ngOnInit(): void {}
}
